var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 10a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0ZM10 2.75a7.25 7.25 0 0 0-5.438 12.045 6.374 6.374 0 0 1 2.878-2.511 3.875 3.875 0 1 1 5.12 0 6.376 6.376 0 0 1 2.878 2.511A7.25 7.25 0 0 0 10 2.75Zm4.305 13.084a4.874 4.874 0 0 0-4.192-2.586 3.868 3.868 0 0 1-.226 0 4.875 4.875 0 0 0-4.192 2.586A7.217 7.217 0 0 0 10 17.25a7.217 7.217 0 0 0 4.305-1.416ZM10.1 11.748a2.375 2.375 0 1 0-.202 0 5.706 5.706 0 0 1 .202 0Z",
    fill: "currentColor"
  })));
};
export default SvgProfile;